import { storage } from './storage.js';

export const isOnboardingDisabled = () => {
  try {
    if (window.__DISABLE_ONBOARDING__ === true) return true;
    if (window.__DISABLE_ONBOARDING__ === false) return false;
  } catch {}

  try {
    const value = storage.get('disable_onboarding');
    if (value === '0') return false; // explicit enable
    if (value === '1') return true;  // explicit disable
    // Default: onboarding enabled (guest gender modal on rankings)
    return false;
  } catch {
    return false;
  }
};


